module.exports = __webpack_public_path__ + "static/react-20ea44b1ccf78f9cde9644a8cb4476cf.png";